<div *ngIf="field" [formGroup]="baseFormGroup" class="form-group">
    <app-aaos-form-field-title [field]="field" [displayText]="field.displayName"></app-aaos-form-field-title>
    <div *ngIf="field.tooltipText" class="smallerText textFieldTooltipText emailTooltipText">{{field.tooltipText}}</div>
    <input class="form-control" [ngClass]="{'readonly': isEmail}" [readonly]="isEmail" formControlName="{{field.name}}"
        [value]="[(field.value)]" (blur)="componentChange($event)">
</div>
